import {observable} from 'mobx';
import {OfferLocaleContent} from './offer-locale-content';
import {construct, createArrayInstance, ModelProperties} from '../utils';

export class OfferLocaleKey {
    @observable id!: number;

    @observable name!: string;

    @observable enabled!: boolean;

    @observable whitespaces!: boolean;

    @observable charLimit!: number;

    @observable content?: OfferLocaleContent[];

    constructor(key?: ModelProperties<OfferLocaleKey>) {
        if (key) {
            construct(this, key);
            this.content = createArrayInstance(OfferLocaleContent, key.content);
        }
    }
}
